// Work Shift and Attendance Permissions
//
// ⚠️ RECONCILE BEFORE RELEASE.
//
// The backend registers these through PermissionService::createAndGrantToOwners
// in database/migrations/2026_09_08_000008_add_attendance_and_leave_permissions.php,
// and the central key service allocates each row's id at migrate time — none of
// them can be known while writing this file. 1538-1547 are counted forward from
// the confirmed 1522 (HR_MANAGE_SETTINGS) in registration order — derived, not
// read.
//
// Read the real ids off the live rows once the migration has run and correct
// these constants:
//
//     SELECT id, name FROM permissions
//     WHERE name LIKE 'work_shifts.%' OR name LIKE 'attendance.%';
//
// The failure mode is deliberately closed: a wrong number means nobody holds it
// and the control is hidden, never shown to the wrong people. Never pick an id
// another permissions file already declares.
export const WORK_SHIFTS_INDEX = 1538;
export const WORK_SHIFTS_CREATE = 1539;
export const WORK_SHIFTS_UPDATE = 1540;
export const WORK_SHIFTS_DELETE = 1541;
export const WORK_SHIFTS_RESTORE = 1542;

export const ATTENDANCE_INDEX = 1543;
export const ATTENDANCE_CREATE = 1544;
export const ATTENDANCE_UPDATE = 1545;
export const ATTENDANCE_DELETE = 1546;
// Separate from ATTENDANCE_CREATE: filling a range writes a month of days in one
// call, which is not the same trust as correcting a single day.
export const ATTENDANCE_FILL = 1547;
